/**
 * Dotted container rendered as a background (group) node in xyflow. Shows
 * "Runs once per ..." label at the top-left.
 */

import type { NodeProps } from '@xyflow/react';
import { ArrowPathRoundedSquareIcon } from '@heroicons/react/24/outline';

export interface FanOutGroupData extends Record<string, unknown> {
  label: string;
}

export function FanOutGroupNode(props: NodeProps) {
  const data = props.data as FanOutGroupData;
  return (
    <div
      className="relative h-full w-full rounded-xl border-2 border-dashed border-indigo-300 dark:border-indigo-500/30 bg-indigo-50/40 dark:bg-indigo-500/10 pointer-events-none"
      style={{ width: '100%', height: '100%' }}
    >
      <div className="absolute -top-3 left-3 flex items-center gap-1.5 rounded-full bg-white dark:bg-neutral-800 px-2 py-0.5 text-[11px] font-medium text-indigo-700 dark:text-indigo-300 ring-1 ring-indigo-300 dark:ring-indigo-500/30">
        <ArrowPathRoundedSquareIcon className="h-3 w-3" />
        Runs once per {data.label}
      </div>
    </div>
  );
}
